import React from 'react';
import { useNode, useEditor } from '@craftjs/core';
import { BuilderNavbarView, type BuilderNavbarViewProps } from './BuilderNavbarView';

export type BuilderNavbarProps = Omit<
  BuilderNavbarViewProps,
  'isEditor' | 'fixed' | 'pathname' | 'innerRef'
>;

/**
 * Nodo CraftJS del navbar. Toda la UI vive en BuilderNavbarView (presentacional,
 * sin hooks de CraftJS) para que el Navbar del layout pueda renderizar EL MISMO
 * navbar en las páginas no-home — ver extractBuilderNavbar en layout/Navbar.tsx.
 */
export const BuilderNavbar = (props: BuilderNavbarProps) => {
  const { connectors } = useNode();
  const { isEnabled } = useEditor((state) => ({
    isEnabled: state.options.enabled,
  }));

  return (
    <BuilderNavbarView
      {...props}
      isEditor={isEnabled}
      innerRef={(el) => { if (el) connectors.connect(el); }}
    />
  );
};

BuilderNavbar.craft = {
  displayName: 'BuilderNavbar',
  props: {
    links: [
      { text: 'Inicio', url: '/' },
      { text: 'Financiamiento', url: '/financing' },
      { text: 'Consignaciones', url: '/consignments' },
      { text: 'Compra directa', url: '/buy-direct' },
    ],
    ctaText: 'Contacto',
    ctaUrl: '/contact',
    bgColor: '#ffffff',
    textColor: '#4b5563',
    ctaBgColor: '',
    ctaTextColor: '#ffffff',
    logoUrl: '',
    logoHeight: 36,
    showLogo: true,
    sticky: true,
    transparentOnTop: true,
    fullWidth: false,
  },
  rules: {
    canDrag: () => true,
    canDrop: () => true,
    canMoveIn: () => false,
  },
};
